module.exports = __webpack_public_path__ + "static/img/apply-to-tea-img.e0559675.png";